import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Layout from '../views/Layout.vue'
import Dashboard from '../views/Dashboard.vue'
import ResourceManage from '../views/ResourceManage.vue'
import CategoryManage from '../views/CategoryManage.vue'
import SystemConfig from '../views/SystemConfig.vue'
import AdminConfig from '../views/AdminConfig.vue'
import MessageManage from '../views/MessageManage.vue'
import AdminProfile from '../views/AdminProfile.vue'
import RoleManage from '../views/RoleManage.vue'
import UserManage from '../views/UserManage.vue'
import FrontUserManage from '../views/FrontUserManage.vue'
import ResourceReview from '../views/ResourceReview.vue'
import MembershipManage from '../views/MembershipManage.vue'
import MembershipOrderManage from '../views/MembershipOrderManage.vue'
import OcrRecognize from '../views/OcrRecognize.vue'
import DocumentList from '../views/DocumentList.vue'
import DocumentHistory from '../views/DocumentHistory.vue'
import DocumentVerifyList from '../views/DocumentVerifyList.vue'
import OcrConfigManage from '../views/OcrConfigManage.vue'
import PdfTemplateConfig from '../views/PdfTemplateConfig.vue'
import OcrCommonConfig from '../views/OcrCommonConfig.vue'
import MenuConfig from '../views/MenuConfigNew.vue'
import CommentManage from '../views/CommentManage.vue'
import SystemLog from '../views/SystemLog.vue'
import SystemMessage from '../views/SystemMessage.vue'
import DictManage from '../views/DictManage.vue'
import WechatPayLog from '../views/WechatPayLog.vue'
import ResourceFindManage from '../views/ResourceFindManage.vue'
import MediaManage from '../views/MediaManage.vue'
import PosterGenerate from '../views/PosterGenerate.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: Dashboard,
        meta: { title: '数据统计' }
      },
      {
        path: 'resource',
        name: 'ResourceManage',
        component: ResourceManage
      },
      {
        path: 'category',
        name: 'CategoryManage',
        component: CategoryManage
      },
      {
        path: 'message',
        name: 'MessageManage',
        component: MessageManage
      },
      {
        path: 'system-message',
        name: 'SystemMessage',
        component: SystemMessage,
        meta: { title: '系统消息' }
      },
      {
        path: 'config',
        name: 'SystemConfig',
        component: SystemConfig,
        meta: { title: '前端系统配置' }
      },
      {
        path: 'admin-config',
        name: 'AdminConfig',
        component: AdminConfig,
        meta: { title: '后端系统配置' }
      },
      {
        path: 'profile',
        name: 'AdminProfile',
        component: AdminProfile,
        meta: { title: '个人信息' }
      },
      {
        path: 'role',
        name: 'RoleManage',
        component: RoleManage,
        meta: { title: '角色管理' }
      },
      {
        path: 'user',
        name: 'UserManage',
        component: UserManage,
        meta: { title: '管理员管理' }
      },
      {
        path: 'front-user',
        name: 'FrontUserManage',
        component: FrontUserManage,
        meta: { title: '前端用户管理' }
      },
      {
        path: 'resource-review',
        name: 'ResourceReview',
        component: ResourceReview,
        meta: { title: '资源审核' }
      },
      {
        path: 'membership',
        name: 'MembershipManage',
        component: MembershipManage,
        meta: { title: '会员等级管理' }
      },
      {
        path: 'membership-order',
        name: 'MembershipOrderManage',
        component: MembershipOrderManage,
        meta: { title: '订单列表' }
      },
      {
        path: 'ocr',
        name: 'OcrRecognize',
        component: OcrRecognize,
        meta: { title: 'OCR证件识别' }
      },
      {
        path: 'document-list',
        name: 'DocumentList',
        component: DocumentList,
        meta: { title: '证件信息列表' }
      },
      {
        path: 'document-history',
        name: 'DocumentHistory',
        component: DocumentHistory,
        meta: { title: '历史证件信息' }
      },
      {
        path: 'document-verify',
        name: 'DocumentVerifyList',
        component: DocumentVerifyList,
        meta: { title: '证件信息校验' }
      },
      {
        path: 'ocr-config',
        name: 'OcrConfigManage',
        component: OcrConfigManage,
        meta: { title: 'OCR配置管理' }
      },
      {
        path: 'pdf-template',
        name: 'PdfTemplateConfig',
        component: PdfTemplateConfig,
        meta: { title: 'PDF模板配置' }
      },
      {
        path: 'ocr-common-config',
        name: 'OcrCommonConfig',
        component: OcrCommonConfig,
        meta: { title: 'OCR通用配置' }
      },
      {
        path: 'comment',
        name: 'CommentManage',
        component: CommentManage,
        meta: { title: '评论管理' }
      },
      {
        path: 'menu-config',
        name: 'MenuConfig',
        component: MenuConfig,
        meta: { title: '菜单配置管理' }
      },
      {
        path: '/admin/system/logs',
        name: 'SystemLog',
        component: SystemLog,
        meta: { title: '系统日志' }
      },
      {
        path: '/admin/system/wechat-pay-logs',
        name: 'WechatPayLog',
        component: WechatPayLog,
        meta: { title: '微信支付日志' }
      },
      {
        path: '/admin/system/dict',
        name: 'DictManage',
        component: DictManage,
        meta: { title: '字典列表' }
      },
      {
        path: 'resource-find',
        name: 'ResourceFindManage',
        component: ResourceFindManage,
        meta: { title: '资源代找管理' }
      },
      {
        path: 'media',
        name: 'MediaManage',
        component: MediaManage,
        meta: { title: '自媒体管理' }
      },
      {
        path: 'poster',
        name: 'PosterGenerate',
        component: PosterGenerate,
        meta: { title: '生成海报' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/admin',
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  if (!token && to.path !== '/login') {
    next('/login')
  } else if (token && to.path === '/login') {
    // 避免重复导航错误
    if (from.path !== '/') {
      next('/')
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
